import {createStore} from "vuex";

const state = {
    titleText: `四川升学服务中心官网`,
    activeMenu: '',
    isFree31: 0, //智能推荐
    isFree35: 0, //位次查询
    isFree36: 0, //一分一段
    isFree37: 0, //分数
    isFree52: 0, //计划
    isFree38: 0, //职升专
    isFree39: 0, //专升本
    userInfo: null,
    volunteers: [], //选择的志愿数据
};
const mutations = {
    updateState(state, items) {
        items.forEach(t => {
            if (Object.hasOwnProperty.call(state, t.key)) {
                state[t.key] = t.value;
            }
        });
    },
};
const getters = {};

const store = createStore({
    state,
    mutations,
    getters,
});

export default store;
